import AppHeadBar from "components/AppHeadBar";

 const HomePages = () => {
  return <AppHeadBar />;
};

export default HomePages;
